import React from "react";
import { X } from "lucide-react";
import useModalDismiss from "../hooks/useModalDismiss";

export default function Modal({
  isOpen,
  onClose,
  title,
  children,
  headerColor = "bg-teal-600",
  zIndex = "z-50",
  maxWidth = "max-w-2xl",
}) {
  const panelRef = useModalDismiss(onClose, isOpen);
  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 ${zIndex} flex items-center justify-center p-3 sm:p-4 modal-backdrop-enter`}>
      {/* Backdrop */}
      <div className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm" />

      {/* Modal */}
      <div
        ref={panelRef}
        className={`relative bg-white rounded-2xl shadow-2xl ring-1 ring-slate-200/70 w-full ${maxWidth} max-h-[92vh] flex flex-col modal-panel-enter overflow-hidden`}>
        {/* Header */}
        <div
          className={`${headerColor} text-white px-6 sm:px-8 py-4 sm:py-5 shrink-0 flex items-center justify-between`}>
          <h2 className="text-base sm:text-lg font-bold tracking-tight">{title}</h2>
          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-4 sm:p-6 md:p-8 overflow-y-auto flex-1">{children}</div>
      </div>
    </div>
  );
}
